import { WeekReport } from "src/database/models/GoalSummary";

export function getRatio({ completed, total }: WeekReport) {
  return total === 0 ? 1 : completed / total;
}

export function getPercentage(summary: WeekReport) {
  return Math.round(getRatio(summary) * 100);
}
